/**
 * @author Ariel
 * @date 2021-12-22
 * @desc 短视频列表页配置
 */
import React from 'react'
import {component_tool} from '../../../tool';
import {WizTableForm} from "../../common";

let {WizModal} = component_tool;
let componentName = 'shortVideo'

const labelConfig = WizTableForm.Config.shortVideoLabel(this, {apiParams: {type: 6}})


const columns = [
  {
    name: 'id',
    formItem: {
      type: 'hidden'
    }
  },
  {
    title: '标题',
    name: 'title',
    searchItem: {},
    tableItem: {
      width:200
    }
  },
  {
    title: '标签',
    name: 'labelId',
    searchItem: {
      ...labelConfig,
      diy: WizTableForm,
      selectType: 'radio',
    }
  },
  {
    title: '标签',
    name: 'labelIds',
    tableItem: {
      render: (text, record) => {
        let labelIds = []
        text && text.length && text.forEach(item => {
          labelIds.push(item.name)
        })
        return labelIds && labelIds.length > 0 ? labelIds.join(",") : ''
      },
      width:200
    }
  },
  {
    title: '分类',
    name: 'categoryIds',
    tableItem: {
      render: (text, record) => {
        let categoryIds = []
        text && text.length && text.forEach(item => {
          categoryIds.push(item.name)
        })
        return categoryIds && categoryIds.length > 0 ? categoryIds.join(",") : ''
      },
      width:200
    }
  },
  {
    title: '发布类型',
    name: 'type',
    tableItem: {},
    dict: [
      {code: 0, codeName: '培训视频'},
      {code: 1, codeName: '店端视频'}
    ]
  },
  {
    title: '发布终端',
    name: 'publishTerminalList',
    searchItem: {
      type: 'select',
    },
    dict: [
      { code: 1, codeName: '移动课堂' },
      { code: 2, codeName: '凯迪拉克IQ' },
      { code: 3, codeName: '雪佛兰企微' },
      { code: 4, codeName: '别克企微' },
      { code: 5, codeName: '凯迪拉克企微' },
    ]
  },
  {
    title: '发布终端',
    name: 'publishTerminalCh',
    tableItem: {},
  },
  {
    title: '发布人',
    name: 'fullName',
    searchItem: {},
    tableItem: {}
  },
  {
    title: '帐号',
    name: 'userName',
    searchItem: {},
    tableItem: {}
  },
  {
    title: '发布类型',
    name: 'type',
    searchItem: {type: 'select'},
    dict: [
      {code: 0, codeName: '培训视频'},
      {code: 1, codeName: '店端视频'}
    ]
  },
  {
    title: '发布时间',
    name: 'releaseTime',
    tableItem: {}
  },
  {
    title: '状态',
    name: 'state',
    tableItem: {},
    searchItem: {type: 'select'},
    dict: [
      {code: 0, codeName: '取消发布'},
      {code: 1, codeName: '发布'},
      {code: 2, codeName: '屏蔽'}
    ]
  },
  {
    title: '评论开关',
    name: 'commentState',
    formItem: {
      type: 'radio',
      initialValue:1
    },
    dict: [
      {code: 1, codeName: '打开'},
      {code: 0, codeName: '关闭'},
    ]
  },
  {
    title: '分享开关',
    name: 'shareState',
    formItem: {
      type: 'radio',
      initialValue:1
    },
    dict: [
      {code: 1, codeName: '打开'},
      {code: 0, codeName: '关闭'},
    ]
  },
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        buttonSort: ['add', 'export'],
        buttons: [
          {
            key: 'add',
            custom: true,
            params: {icon: 'plus', children: '创建', type: 'primary'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/shortVideo/shortVideoDetailAdd',
              }
            }
          },
          {
            key: 'export',
            custom: true,
            params: {icon: 'export', children: '导出', type: 'export'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: "export",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return {...filters}
              }
            }
          },
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        bordered: false,
        paging: false,
        loading: false
      },
      rowOperateSort: ['look', 'releaseOrUnpublish', 'delete', 'recordManagement'],
      rowOperateView: [
        {
          key: 'releaseOrUnpublish',
          custom: true,
          params: {children: "发布"},
          textFormat: {
            recordKey: 'state',
            dirt: {0: '发布', 1: '取消发布', 2: '发布'}
          },
          customOnClick: {
            key: "action",
            params: {
              apiKey: "enable",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              let statusNameStr;
              switch (record['state']) {
                case 0:
                case 2:
                  statusNameStr = '发布'
                  break;
                case 1:
                  statusNameStr = '取消发布'
                  break;
                default:
                  statusNameStr = ''
                  return null
              }
              const content = `您确定要` + statusNameStr + `该视频吗？`;
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    state: record['state'] === 0 ? 1 : 0,
                    id: record['id']
                  })
                },
                onCancel() {
                }
              });
              return null
            }
          },
          recordChangeParams: ({record, rows}) => {
            let personId = storage.getStorage('user') && storage.getStorage('user').personId;
            let is = personId !== record.createBy || record.state == 2
            return {hidden: is}
          },
        },
        {
          key: "delete",
          custom: true,
          params: {children: "删除"},
          customOnClick: {
            key: "action",
            params: {
              apiKey: "delete",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              const content = '删除后数据不可恢复，您确定要删除该视频么？'
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    id: record.id
                  })
                },
                onCancel() {
                }
              });
              return null
            }
          },
          recordChangeParams: ({record, rows}) => {
            let personId = storage.getStorage('user') && storage.getStorage('user').personId;
            let is = personId !== record.createBy
            return {hidden: is}
          },
        },
        {
          key: "look",
          custom: true,
          params: {children: "查看"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/shortVideo/look"
            }
          }
        },
        {
          key: "recordManagement",
          custom: true,
          params: {children: "记录管理"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/shortVideo/record"
            }
          }
        },
      ],
      commonOperate: {
        add: true,
        delete: true,
        update: true,
        enable: true
      }
    }
  }
}

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
  update: {
    path: `${componentName}/updateSet`,
    payload: {
      key: `${componentName}@updateSet`,
      apiParams: {}
    }
  },
  enable: {
    path: `${componentName}/enable`,
    payload: {
      key: `${componentName}@enable`,
      apiParams: {}
    }
  },
  delete: {
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams: {}
    }
  },
}

let reduxTemplateConfig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};
